import { CSSObject } from "@emotion/react";

import {
  ModalSubFeedbackBody,
  ModalSubFeedbackFooter,
  ModalSubFeedbackHeader,
} from "~components/ModalSubFeedback/ModalSubFeedback";
import { translate } from "~utils";

type ModalSubFeedbackContentPositiveSummaryProps = {
  onDismiss: () => void;
};

const styles: Record<string, CSSObject> = {
  bodyContainer: {
    display: "flex",
    flex: 4,
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    marginTop: 36,
    textAlign: "center",
  },
};

export function ModalSubFeedbackContentPositiveSummary(
  props: ModalSubFeedbackContentPositiveSummaryProps,
) {
  const { onDismiss } = props;

  return (
    <>
      <ModalSubFeedbackHeader title={translate("FEEDBACK_SUBMITTED_LABEL")} onDismiss={onDismiss} />
      <ModalSubFeedbackBody>
        <div css={styles.bodyContainer}>
          <img
            css={{ width: 200, height: 200 }}
            src="assets/positive-heart.png"
            alt="heart with family"
          />
          <h3>{translate("MSF_SUMMARY_TITLE")}</h3>
          <p>{translate("MSF_POSITIVE_SUMMARY_BODY")}</p>
        </div>
      </ModalSubFeedbackBody>
      <ModalSubFeedbackFooter
        buttonPrimary={{ onClick: onDismiss, isDisabled: false, text: "Close" }}
      />
    </>
  );
}
